import * as axios from 'axios';
import { getBaseServiceUrl } from '@/helpers/settingsHelper';

export default function confirmRegistration(userId: string) {
    const url = `${getBaseServiceUrl()}/account/register/confirm/${userId}`;

    return axios.default.get<boolean>(url);
}